"use strict";

var __values = this && this.__values || function (o) {
  var s = typeof Symbol === "function" && Symbol.iterator,
      m = s && o[s],
      i = 0;
  if (m) return m.call(o);
  if (o && typeof o.length === "number") return {
    next: function next() {
      if (o && i >= o.length) o = void 0;
      return {
        value: o && o[i++],
        done: !o
      };
    }
  };
  throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.UsagePoints = void 0;

var usage_points_1 = __importDefault(require("./http/usage_points"));

var usage_point_1 = require("./usage_point"); //import { load } from './storage/units';
// perhaps wrap these functions in a namespace


var UsagePoints;

(function (UsagePoints) {
  function find(uuid, usagePoints) {
    var e_1, _a;

    try {
      for (var usagePoints_1 = __values(usagePoints), usagePoints_1_1 = usagePoints_1.next(); !usagePoints_1_1.done; usagePoints_1_1 = usagePoints_1.next()) {
        var up = usagePoints_1_1.value;

        if (uuid.equals(up.uuid)) {
          return up;
        }
      }
    } catch (e_1_1) {
      e_1 = {
        error: e_1_1
      };
    } finally {
      try {
        if (usagePoints_1_1 && !usagePoints_1_1.done && (_a = usagePoints_1.return)) _a.call(usagePoints_1);
      } finally {
        if (e_1) throw e_1.error;
      }
    }
  }

  UsagePoints.find = find;

  function findAndReplace(u, usagePoints) {
    for (var i = 0; i < usagePoints.length; i++) {
      if (usagePoints[i].uuid.equals(u.uuid)) {
        usagePoints[i] = u;
        return usagePoints;
      }
    }

    return usagePoints;
  }

  UsagePoints.findAndReplace = findAndReplace;
  /**
   * Merge merges two sets of UsagePoints into one, where the first parameter is the newer data and the second one contains the source
   * @param newUps - The changes to be merge into the source
   * @param source  - The source array used
   */

  function merge(newUps, source) {
    for (var i = 0; i < newUps.length; i++) {
      var replaced = false;

      for (var j = 0; j < source.length; j++) {
        if (newUps[i].uuid.equals(source[j].uuid)) {
          source[j] = newUps[i];
          replaced = true;
        }
      }

      if (!replaced) {
        source.push(newUps[i]);
      }
    }

    return source;
  }

  UsagePoints.merge = merge;

  function get(credentials, time, fields, limitExpression) {
    if (limitExpression === void 0) {
      limitExpression = "";
    }

    return usage_points_1.default(time, limitExpression, fields, credentials).then(function (resp) {
      var e_2, _a;

      var ret = [];

      try {
        for (var resp_1 = __values(resp), resp_1_1 = resp_1.next(); !resp_1_1.done; resp_1_1 = resp_1.next()) {
          var d = resp_1_1.value;
          ret.push(usage_point_1.decodeUsagePoint(d));
        } // Not currently testable

      } catch (e_2_1) {
        e_2 = {
          error: e_2_1
        };
      } finally {
        try {
          if (resp_1_1 && !resp_1_1.done && (_a = resp_1.return)) _a.call(resp_1);
        } finally {
          if (e_2) throw e_2.error;
        }
      }

      return ret;
    });
  }

  UsagePoints.get = get;
})(UsagePoints = exports.UsagePoints || (exports.UsagePoints = {}));